<template>
<div class="col-10 box-border">
    <div class="w-100 d-flex details mt-0 align-items-center">
        <div class="col-5 d-flex align-items-center">
            <!-- NAME INITIALS ITEM -->
            
            <el-skeleton style="width: 60%; height: 50px;" animated v-if="!isProviderNotEmpty">
                <template slot="template">
                    <el-skeleton-item variant="rect" style="width: 60%; height: 50px;" />
                </template>
            </el-skeleton>
            <div v-else >
                <NameInitials :name="provider.tradingName || provider.name || '-'" />
            </div>

            <!-- PROVIDER NAME & CNPJ ITEM -->
            <el-skeleton v-if="!isProviderNotEmpty" animated >
                <el-skeleton-item rows="1" variant="h3"/>
                <el-skeleton-item rows="1" variant="p"/>
            </el-skeleton>
            <div v-else class="break-col">
                <el-tooltip :content="provider.name" placement="top">
                    <h4 class="bold c-ndarkfour break mb-1">{{ provider.tradingName || provider.name || '-'}}</h4>
                </el-tooltip>
                <p class="bold c-nmidone mt-n2 mb-0">{{provider.cnpj ? provider.cnpj.cnpj : '-' | formatCnpjOrCpf}}</p>
            </div>
        </div>
        <div class="col break-col d-flex justify-items-center flex-column">
            <caption class="c-nmidone">Local</caption>
            <!-- PROVIDER LOCATION ITEM -->
            <el-skeleton rows="1" v-if="!isProviderNotEmpty" animated />
            <h5 v-else class="bold c-ndarkfour break mb-0">{{ provider.headquarters ? `${provider.headquarters.city}/${provider.headquarters.state}` : '-' }}</h5>
        </div>
        <div class="col break-col d-flex justify-items-center flex-column">
            <caption class="c-nmidone pt-1 mb-0">website</caption>
            <!-- WEBSITE ITEM --> 
            <el-skeleton rows="1" v-if="!isProviderNotEmpty" animated />
            <el-tooltip v-else class="item" :disabled="!provider.website" :content="provider.website" placement="top">
                <a target="_blank" class="c-ndarkfour p-0" :href="provider.website || `#`">
                    <h5 class="bold break mb-0">{{ provider.website || '-' }}</h5>
                </a>
            </el-tooltip>
        </div>
        <div class="col-3 pr-0 d-flex justify-content-end">
            <a v-if="provider.id" :href="`/provider/${provider.id}/status`" class="px-0">
                <Button size="small" type="outline" :color="getPrimaryColor" class="ml-0 resize-btn">
                    Situação cadastral
                </Button>
            </a>
        </div>
    </div>

    <div class="row">
        <div class="col-12 my-3 pb-2">
            <hr>
        </div>
        <!-- RATING ITEM -->
        <div class="col-3">
            <h5 class="medium c-darkfour mb-3">Reputação</h5>
            <el-skeleton style="width: 100%; height: 80px;" animated v-if="!ratingDataNotEmpty">
                <template slot="template">
                    <el-skeleton-item variant="rect" style="width: 100%; height: 80px;" />
                </template>
            </el-skeleton>
            <div v-else>
                <ViewRating :cnpjProvider="provider.cnpj.cnpj" />
                <router-link
                    v-if="ratingData.allScores.length !== 0"
                    to="" 
                    :class="`c-${getPrimaryColor}four`" 
                    @click.native="dialogVisibleUsersRating=true"
                >
                    Ver comentários
                </router-link>
            </div>
        </div>
        <div class="offset-2 col-7 px-0">
            <h5 class="medium c-ndarkfour mb-0">Histórico na plataforma</h5>
            <div class="row mt-4">
                <!-- OPERATIONS START DATE ITEM -->
                <div class="col-6 d-flex align-items-center mb-4">
                    <div class="icon-history mr-3">
                        <Date color="#A1A8B8" />
                    </div>
                    <div>
                        <caption class="c-nmidone">Início das operações</caption>
                        <el-skeleton rows="1" variant="h4" v-if="!isProviderNotEmpty" animated />
                        <h4 v-else class="bold c-ndarkfour mb-0">{{ provider.createdAt || '-' | formatDate}}</h4>
                    </div>
                </div>

                <!-- DELIVERY INDEX ITEM -->
                <div class="col-6 d-flex align-items-center mb-4">
                    <div class="icon-history mr-3">
                        <IconIndex />
                    </div>
                    <div>
                        <caption class="c-nmidone">índice de entrega
                            <el-tooltip class="item" placement="top">
                                <div slot="content">
                                    O índice de entrega se refere à porcentagem de pedidos que<br> tiveram suas mercadorias/serviços entregues com sucesso.
                                </div>
                                <Question class="mt-n1" color="#A1A8B8" />
                            </el-tooltip>
                        </caption>
                        <h4 class="bold c-ndarkfour mb-0">-</h4>
                    </div>
                </div>
                <div class="col-6 d-flex align-items-center mt-4">
                    <div class="icon-history mr-3">
                        <AmountNF />
                    </div>
                    <div>
                        <caption class="c-nmidone">qtde. notas fiscais</caption>
                        <el-skeleton rows="1" variant="h4" v-if="!isCompanyInfoNotEmpty" animated />
                        <h4 v-else class="bold c-ndarkfour mb-0">{{companyInfo.provider ? companyInfo.provider.operations : '-'}}</h4>
                    </div>
                </div>
                <div class="col-6 d-flex align-items-center mt-4">
                    <div class="icon-history mr-3">
                        <MoneyTax />
                    </div>
                    <div>
                        <caption class="c-nmidone">Total de NF</caption>
                        <el-skeleton rows="1" variant="h4" v-if="!isCompanyInfoNotEmpty" animated />
                        <h4 v-else class="bold c-ndarkfour mb-0">R$ {{companyInfo.provider ? companyInfo.provider.totalValue : '-' | formatMoney}}</h4>
                    </div>
                </div>
            </div>
        </div>
    </div>
    <UsersRating
        :dialogVisible="dialogVisibleUsersRating"
        :ratedCompanyName="provider.tradingName || provider.name"
        :usersCommentsData="ratingData.allScores"
        @closeModal="dialogVisibleUsersRating=$event"
    />
</div>
</template>

<script>
import MoneyTax from '@/components/icons/MoneyTax'
import Question from '@/components/icons/Question'
import NameInitials from '@/components/icons/NameInitials'
import ViewRating from '@/components/rating/ViewRating'
import AmountNF from '@/components/icons/AmountNF'
import IconIndex from '@/components/icons/IconIndex'
import Date from '@/components/icons/Date'
// Modals
import UsersRating from '@/components/modals/UsersRating'
// API
import getRating from '@/api/getRating'
export default {
    props: {
        provider: {
            required: true,
            default: {}
        },
        companyInfo: {
            required: true,
            default: {}
        }
    },
    data() {
        return {
            ratingData: {
            },
            dialogVisibleUsersRating: false,
        }
    },
    components: {
        MoneyTax,
        Question,
        NameInitials,
        ViewRating,
        IconIndex,
        AmountNF,
        Date,
        UsersRating

    },
    methods: {
        isNotEmpty(value) {
            const keys = Object.keys(value)
            return !!keys.length 
        }
    },
    computed: {
        isProviderNotEmpty() {
            return this.isNotEmpty(this.provider)
        },
        isCompanyInfoNotEmpty() {
            return this.isNotEmpty(this.companyInfo)
        },
        ratingDataNotEmpty() {
            return this.isNotEmpty(this.ratingData)
        }
    },
    async created () { 
        if (this.isProviderNotEmpty){
            const ratingData = await getRating(this.provider.cnpj.cnpj)
            this.ratingData = ratingData.payload
        }
    },
}
</script>

<style lang="scss" scoped>
    .icon-history {
        width: 40px;
    }

    .logo {
        max-width: 50px;
    }

    hr {
        height: 1px !important;
        border: unset;
        background-color: #DFE2EB;
    }

    a:hover {
        text-decoration: none !important
    }

    @media (max-width: 1415px) {
        .btn.small {
            padding-left: 15px;
            padding-right: 15px;
        }
    }
</style>
